import { Stack, StackProps } from 'rsuite'
import { useRouter } from 'next/router'
import { FC } from 'react'

import UseCaseTag from '../../UseCaseTag'
import useUrls from '../../../services/useUrls'
import useCategoryDataStructure from '../../hooks/useCategoryDataStructure'
import { ShortcutUseCaseData, ShortcutUseCaseLablesWithIds } from '../../../utils/constants'

const UseCaseTagList: FC<StackProps> = (props) => {
  const { selectedCategory } = useCategoryDataStructure()
  const { query, asPath } = useRouter()

  const labels = ShortcutUseCaseData[selectedCategory]

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { filters: _, ...restOfQuery } = query

  const { pushT } = useUrls()

  const queryParams = new URLSearchParams(restOfQuery as { [key: string]: string })
  const useCaseIds = queryParams.get('f_use-case')?.split('-') || []

  const activatedId = useCaseIds.find((currentId) => currentId in ShortcutUseCaseLablesWithIds)

  const onTagClick = (labelId: string, shouldRemoveId = false) => {
    // Don't do anything if the label is already activated and user is not clicking on X button
    if (labelId === activatedId && !shouldRemoveId) {
      return
    }

    const uniqueValuesSet = new Set([...useCaseIds, labelId])

    if (shouldRemoveId) {
      uniqueValuesSet.delete(labelId)
    }

    const uniqueValues = [...uniqueValuesSet]
    const uniqueValuesString = uniqueValues.join('-')

    if (uniqueValues.length) {
      queryParams.set('f_use-case', uniqueValuesString)
    } else {
      queryParams.delete('f_use-case')
    }

    pushT({ pathname: asPath.split('?')[0], query: queryParams.toString() })
  }

  const renderList = () => {
    if (activatedId) {
      return (
        <UseCaseTag
          onClick={() => onTagClick(activatedId)}
          onClose={() => onTagClick(activatedId, true)}
          isActive
          label={ShortcutUseCaseLablesWithIds[activatedId]}
          closable
        />
      )
    }

    return labels?.map((labelId) => (
      <UseCaseTag
        onClick={() => onTagClick(labelId)}
        label={ShortcutUseCaseLablesWithIds[labelId]}
        key={labelId}
      />
    ))
  }

  return (
    <Stack
      direction="column"
      spacing={15}
      alignItems="baseline"
      {...props}
    >
      {renderList()}
    </Stack>
  )
}

export default UseCaseTagList
